import { injectable } from 'tsyringe';
import { nanoid } from 'nanoid';
import { IWrapId } from './IWrapId';

@injectable()
export class WrapId implements IWrapId {
    constructor() { }

    public generate = (): string => {
        return nanoid();
    }
}
